<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <strong>Route Configuration</strong>
            </div>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <b-row>
                    <b-col sm="3">
                      <label for="Hub"><b>Hub</b></label>&nbsp;<span style="color: red;">*</span>
                    </b-col>
                    <b-col sm="9">
                      <v-select v-model="selectedHub" :options="optionsHub" placeholder="-- Select Hub --" @input="updateSelect"></v-select>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-button variant="primary" :pressed.sync="myToggle"
                  @click="getUserWiseListing(pageNum)">Submit</b-button>
                <b-button type="submit" size="md" variant="danger" @click="clear()" style="margin-left: 10px"> clear</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="text-right">
                  <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
              </b-col>
              <b-col sm="12">
                <b-table show-empty responsive :items="useritems" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy">
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  <template slot="destinationcompany1" slot-scope="row">
                    <button style="background-color:white !important;" @click="viewFrequencyDetails(row.item.userid1)" class="btn btn-link nav-link"
                    :title="row.item.destinationcompany1">
                    <span  style="color:#1b8eb7">
                        {{ row.item.destinationcompany1 != null?row.item.destinationcompany1+' - '+row.item.userid1:row.item.userid1}}</span>
                     </button>
                  </template>
                  <template slot="destinationcompany2" slot-scope="row">
                    <!-- <b-button size="sm" @click="viewFrequencyDetails(row.item.userid2)">{{ row.item.userid2 }}</b-button> -->
                    <button style="background-color:white !important;" @click="viewFrequencyDetails(row.item.userid2)" class="btn btn-link nav-link"
                    :title="row.item.destinationcompany2">
                    <span style="color:#1b8eb7">
                        {{ row.item.destinationcompany2 != null? row.item.destinationcompany2+' - '+row.item.userid2:row.item.userid2}}</span>
                        
                     </button>
                  </template>
                  <!-- <template slot="frequency" slot-scope="row">
                
                  <button style="background-color:white !important;" @click="row.toggleDetails" class="btn btn-link nav-link">
                    <span style="color:#1b8eb7" v-bind:id="'frequency' + row.item.frequency" >{{ row.item.frequency ? row.item.frequency : '0'}} </span>   <i class="fa fa fa-pencil-square-o" style="color:#1b8eb7"></i>
                 
                  </button>
                 </template> -->
                 <template slot="row-details" slot-scope="row">
                  <b-card>
                      <b-row>
                        <b-col sm="4">
                          <form @submit.prevent="increaseFrequency(row.item)">       
                            <b-input-group >
                              <!-- Attach Left button -->
                               <b-form-input type="number"  min="0"  v-model="row.item.frequency"  ></b-form-input>
                              <b-input-group-prepend>
                                <b-button type="submit"  variant="primary">
                                  Save <i class="fa fa-save"></i> 
                                </b-button>
                              </b-input-group-prepend> 
                            </b-input-group>      
                          </form>
                        </b-col>
                      </b-row>
                    </b-card>
                 </template>
                  <!-- <template slot="action" slot-scope="row">
                    <div>
                      <b-button size="sm" @click="viewFrequencyDetails(row.item)"><i class="fa fa-eye" aria-hidden="true"></i></b-button>
                    </div>
                  </template> -->
                </b-table>
              </b-col>
              <b-col md="6" class="my-1" >
                <paginate 
                  v-model="pageNum"
                  :page-count="noofpages"
                  :page-range="5"
                  :margin-pages="1"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate>
              </b-col>
              <b-col md="6" class="text-right" v-if="totalRows>0">
                <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-modal v-model="viewFrequency" hide-footer title="Frequency Details" size="xl">
                  <div class="d-block text-center">
                    <b-row>
                      <b-col md="12" class="text-right">
                        <b text-variant="red">Total Records :<span style="color: red;"> {{totalRowsFrequency}}</span></b>
                      </b-col>
                      <b-col md="12">
                        <b-table show-empty responsive stacked="md"  :items="frequencyItem"  :fields="frequencyFields" :current-page="currentPageFrequnecy"  :per-page="perPageFrequnecy"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" :bordered="bordered"    :outlined="outlined" :busy="isBusyFrequency" >
                          <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                          <template slot="destinationcompany1" slot-scope="row">
                            <span  style="color:#1b8eb7">
                                {{ row.item.destinationcompany1 != null?row.item.destinationcompany1+'-'+row.item.userid1:row.item.userid1}}</span>
                           
                          </template>
                          <template slot="destinationcompany2" slot-scope="row">
                            <span style="color:#1b8eb7">
                                {{ row.item.destinationcompany2 != null? row.item.destinationcompany2+' - '+row.item.userid2:row.item.userid2}}</span>
                          </template>
                        </b-table>
                      </b-col>
                      <b-col md="12" class="my-1 " v-if="this.totalRowsFrequency > 10">
                        <b-pagination v-model="currentPageFrequnecy" :total-rows="totalRowsFrequency" :per-page="perPageFrequnecy" class="my-0"></b-pagination>
                      </b-col>
                      
                    </b-row>
                  </div>
                  <b-button class="mt-3 float-right" variant="danger" @click="closeModal()">Close</b-button>
                </b-modal>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  <script>
    //  import DirectionsRenderer from "./DirectionsRenderer";
     import spinner from './Loader/spinner.vue';
    //  import customMarker from "./customMarker.vue";
    import CONSTANTS from "@/utils/constants";
    import Utils from "@/utils";
    import Vue from "vue";
    export default {
      data() {
        return {
          optionsHub: [],
          HubData: [],
          vehicleData:[],
          fieldVehicle: {
            text: 'name',
            value: 'id'
          },
          selectedHub: '',
          fields:[
            { key: 'destinationcompany1', label: 'Start Point', sortable: true, sortDirection: 'desc' },
            { key: 'destinationpincode1', label: 'Start Pincode', sortable: true},  
            { key: 'destinationaddress1', label: 'Start Address', sortable: true },
            { key: 'destinationcompany2', label: 'End Point', sortable: true},
            { key: 'destinationpincode2', label: 'End Pincode', sortable: true }, 
            { key: 'destinationaddress2', label: 'End Address', sortable: true },
            { key: 'hubcity', label: 'Hub City', sortable: true},
            { key: 'frequency', label: 'Frequency', sortable: true },
            // { key: 'action', label: 'Frequency Details', sortable: true },    
          ],
          isBusy: false,
          currentPage: 1,
          perPage:  100,
          sortBy: null,
          sortDesc: false,
          sortDirection: 'asc',
          noofpages:0,
          pageNum:1,
          totalRows :0,
          useritems :[],
          viewFrequency:false,
          frequencyItem:[],
          frequencyFields:[
            { key: 'destinationcompany1', label: 'Start Point', sortable: true, sortDirection: 'desc' },
            { key: 'dest1pincode', label: 'Start Pincode', sortable: true},  
            { key: 'dest1address', label: 'Start Address', sortable: true },
            { key: 'destinationcompany2', label: 'End Point', sortable: true},   
            { key: 'dest2pincode', label: 'End Pincode', sortable: true },
            { key: 'dest2address', label: 'End Address', sortable: true },
            { key: 'frequency', label: 'Frequency', sortable: true },
          ],
          isBusyFrequency:false,
          perPageFrequnecy:20,
          currentPageFrequnecy:1
        };
      },
      components: {
      // DirectionsRenderer,
      spinner,
      // customMarker,
      },
      created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        
        this.showWHlist();
        
      },
      methods: {
        showWHlist: function() {
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype:`${userInfo.user_type}`
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj).then(result => {
            if (result.body.returnmsg === 'Successful') {
              this.optionsHub = [];
              this.HubData = result.body.returnvalue;
              var data = [];
              this.HubData.forEach(function(srData) {
                data.push({
                  key: srData.hubid,
                  label: srData.hubid + " - " + srData.hubname
                });
              });
              this.optionsHub = data;
            } else {
              this.HubData = [];
            }
          }).catch(ex => {
            console.log("error-----", ex);
          });
        },
        clear(){
          this.selectedHub='';
          this.noofpages=0;
          this.useritems=[];
          this.totalRows=0;
          this.pageNum=1;
          this.frequencyItem=[];
          this.totalRowsFrequency=0;
        },
        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.getUserWiseListing(pageNum);
        },
        getUserWiseListing(pageNum){
        this.isBusy=true;
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        let getHubName =this.selectedHub.label.split('-');
          let trimSpace=getHubName[1].trim();
          console.log("YYYYYYYYYYYYYYYYYYY---------->",getHubName,trimSpace)
          var csvObj = {
            hubid:`${this.selectedHub.key}`,
            hubcity:`${trimSpace}`,
            pageno:pageNum
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllUserIdsListingForRouting`, csvObj).then(result => {
            // console.log("result.body----------->",result.body)
            this.isBusy=false;
            if (result.body.returnmsg === 'Successful') {
               this.useritems=result.body.returnvalue;
               this.totalRows = result.body.totalcount;
               this.noofpages=parseInt(this.totalRows)/100;
               this.noofpages=Math.ceil( this.noofpages);
            } else {
                this.useritems=[];
                this.totalRows =0;
            }
          }).catch(ex => {
            console.log("error-----", ex);
          });
        },
        viewFrequencyDetails(userid){
            this.viewFrequency=true;
            this.isBusyFrequency=true;
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            var csvObj = {
                hubid:`${this.selectedHub.key}`,
                userid:`${userid}`,
            };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getUserFrequecyForLocations`, csvObj).then(result => {
            
            this.isBusyFrequency=false;
            if (result.body.returnmsg === 'Successful') {
              this.frequencyItem=result.body.returnvalue;
              this.totalRowsFrequency=result.body.returnvalue.length;
            } else {
                this.frequencyItem = [];
                this.totalRowsFrequency = 0;
            }
          }).catch(ex => {
            console.log("error-----", ex);
          });
        },
        closeModal(){
            this.viewFrequency=false;
        },
        increaseFrequency(item) {
        if(item.frequency==0){
          this.$fire({
            text: "Frequency Can't be 0",
            type: "warning",
            timer: 30000
          }); 
          return false;
        }
        const Obj = {
          hubid:`${this.selectedHub.key}`,
          start_userid:`${item.userid1}`,
          end_userid:`${item.userid2}`,
          start_pincode:`${item.destinationpincode1}`,
          end_pincode:`${item.destinationpincode2}`,
          frequency:`${item.frequency}`,
        };
        console.log('Obj----------->',Obj);
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateFrequencyCountForRouteMapping`,Obj).then(result => {
            if (result.body.returnmsg === "Successful") {
              this.$fire({
                  text: "Frequency Increased Successfully",
                  type: "success",
                  timer: 30000
                }); 
                this.getUserWiseListing(this.pageNum);
            } else {
              this.$fire({
                  text: "Error in Updating Frequency",
                  type: "error",
                  timer: 30000
                }); 
            }
          })
          .catch(ex => {
            console.log("error", ex);
          });
    },
      },
   
    };
  </script>
  <style scoped>
  .custom-source-marker-container {
    position: absolute;
    z-index: 999; /* Adjust the z-index value to ensure it's above the DirectionsRenderer markers */
    top: 0; /* Adjust positioning as needed */
    left: 0; /* Adjust positioning as needed */
  }
    .routetable th,
    td {
      text-align: center;
    }
  
    .route-border {
      border-bottom: 1px solid #c9bebe;
      margin: 30px 0px 20px 0px;
    }
  
    #overlay {
      position: fixed;
      /* Sit on top of the page content */
      /*display: none;*/
      /* Hidden by default */
      width: 100%;
      /* Full width (cover the whole page) */
      height: 100%;
      /* Full height (cover the whole page) */
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      /* Black background with opacity */
      z-index: 9999;
      /* Specify a stack order in case you're using a different order for other elements */
      cursor: pointer;
      /* Add a pointer on hover */
    }
  
    .loader {
      position: fixed;
      ;
      border: 5px solid #f3f3f3;
      border-radius: 50%;
      border-top: 5px solid #3498db;
      width: 50px;
      height: 50px;
      left: 50%;
      top: 50%;
      -webkit-animation: spin 2s linear infinite;
      /* Safari */
      animation: spin 2s linear infinite;
    }
  
    .loading {
      position: relative;
      width: 50px;
      height: 50px;
      left: 50%;
      top: 56%;
    }
    .customMarker{
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: -1;
    }
    /* Safari */
    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
  
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
  
      100% {
        transform: rotate(360deg);
      }
    }
    .dot{
      margin: 5px;
    }
    .red-dot {
    width: 20px;
    height: 20px;
    background-color: red;
    border-radius: 50%;
    display: inline-block;
    border: 2px black solid;
  }
  .green-dot {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 50%;
    display: inline-block;
    border: 2px black solid;
  }
  .yellow-dot {
    width: 20px;
    height: 20px;
    background-color: yellow;
    border-radius: 50%;
    display: inline-block;
    border: 2px black solid;
  }
  .modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
  }
  
  .close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  
  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
  </style>